module.exports = __webpack_public_path__ + "icon-minus-2.png?5b77d5c30b5eee03a02e3a29ad2eeff1";


//////////////////
// WEBPACK FOOTER
// ./Content/img/icon-minus-2.png
// module id = 644
// module chunks = 1